import React, { useMemo } from "react";
import { motion } from "motion/react";
import { useResponsive } from "../utils/responsiveContext";
import { timeline } from "../utils/timeline";

export const Timeline = () => {
  const { isMobile } = useResponsive();
  const timelineData = useMemo(() => timeline, []);
  const currentYear = new Date().getFullYear();
  const angleIncrement = 360 / timelineData.length;
  const radius = isMobile ? 550 : 730;

  return (
    <div className="w-full h-full flex items-center justify-center overflow-hidden py-10 px-10 relative select-none">
      <div
        className="relative w-full h-full flex items-center justify-center"
        style={{
          perspective: isMobile ? "2200px" : "2000px",
          perspectiveOrigin: "center center",
        }}
      >
        <div
          className="carousel-3d relative flex items-center justify-center"
          style={{
            transformStyle: "preserve-3d",
            backfaceVisibility: "visible",
            width: "300px",
            height: "600px",
          }}
        >
          {timelineData.map((item, index) => {
            const isFuture =
              item.date === "Future" || Number(item.date) > currentYear;
            const angle = angleIncrement * index;
            const isCurrent = item.isCurrent ? true : false;

            return (
              <motion.div
                key={index}
                className="absolute flex flex-col items-center justify-center"
                style={{
                  transformStyle: "preserve-3d",
                  transform: `rotateY(${angle}deg) translateZ(${radius}px)`,
                  width: isMobile ? "250px" : "270px",
                  height: "100%",
                  left: "50%",
                  top: "50%",
                  marginLeft: "-135px",
                  marginTop: "-300px",
                  backfaceVisibility: "visible",
                  willChange: "transform",
                }}
              >
                <span
                  className="text-white mb-2 text-sm md:text-base font-semibold select-none"
                  style={{
                    backfaceVisibility: "visible",
                  }}
                >
                  {item.date}
                </span>

                <div
                  className={`w-5 h-5 rounded-full border-2 border-white relative z-10 ${
                    isFuture ? "bg-yellow-500" : "bg-green-400"
                  } ${isCurrent && !isFuture ? "blink-current bg-red-500" : ""}`}
                  style={{
                    backfaceVisibility: "visible",
                    boxShadow: `0 0 20px ${
                      isFuture
                        ? "rgba(251, 191, 36, 0.6)"
                        : "rgba(74, 222, 128, 0.6)"
                    }`,
                  }}
                />

                <motion.div
                  className={`mt-2 rounded-3xl p-4 bg-shade-2 text-center text-white flex flex-col justify-center cursor-pointer ${item.className}`}
                  style={{
                    width: isMobile ? "200px" : "270px",
                    aspectRatio: "9/16",
                    backfaceVisibility: "visible",
                    transformStyle: "preserve-3d",
                    boxShadow:
                      "rgba(240, 46, 170, 0.6) 3.46px 1px,rgba(46, 240, 170, 0.5) 6.93px 2px,rgba(170, 46, 240, 0.4) 10.39px 3px,rgba(240, 170, 46, 0.3) 13.86px 4px, rgba(46, 170, 240, 0.2) 17.32px 5px",
                  }}
                  animate={{ rotateX: -5 }}
                >
                  <p className="md:text-xl text-md font-semibold mb-2">
                    {item.title}
                  </p>
                  <p className="md:text-sm text-xs font-light">
                    {item.description}
                  </p>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
